// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1QsLv","colMin":"styles_colMin__Kzzeu","colCheckbox":"styles_colCheckbox__2t4NU"};